"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const InformationPage_vue_1 = __importDefault(require("../../pages/informationPage/InformationPage.vue"));
exports.default = [
    {
        name: 'information_page',
        path: '/information',
        component: InformationPage_vue_1.default,
        meta: { requiresAuth: true, title: 'Information page' }
    },
    {
        name: 'admin_get_information_box_items',
        path: '/api/get-information-box-items',
        redirect: '',
        meta: { requiresAuth: true }
    },
];
